// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2wy7l","row":"ProcedureTreatmentSummary_row__2InUd"};